import HeaderMenuProps from "@/src/_types/header-menu-props";
import ButtonMenu from "@/src/components/main-site/_partials/header/mui-custom/button-menu/button-menu";
import Link from "next/link";
import {Box, MenuItem} from '@mui/material';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown} from "@fortawesome/pro-duotone-svg-icons";
import {useTheme} from '@mui/material/styles';

const DesktopMenu = ({menuItems}: HeaderMenuProps) => {
    const theme = useTheme();

    return (
        <>
            {
                menuItems?.map((item, index) => (
                    <Box
                        key={index}
                        sx={{
                            position: 'relative',
                            '&:hover .submenu': {
                                display: 'block'
                            },
                        }}
                    >
                        {item.children ? (
                            <>
                                <ButtonMenu
                                    className="menu-button"
                                    sx={{
                                        fontWeight: 700,
                                        textTransform: 'none',
                                        display: 'flex',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <i className={item.icon}/>
                                    {item.label}
                                    <FontAwesomeIcon
                                        icon={faChevronDown}
                                    />
                                </ButtonMenu>
                                <Box
                                    className="submenu"
                                    sx={{
                                        display: 'none',
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        backgroundColor: (theme) => theme.palette.custom?.menuBackground,
                                        boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.1)',
                                        zIndex: 10,
                                    }}
                                >
                                    {item.children.map((child, childIndex) => (
                                        <MenuItem
                                            component={Link}
                                            key={childIndex}
                                            href={child.link ?? '#'}
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 0.3,
                                                fontSize: '.9rem',
                                                fontWeight: 400,
                                                '&:hover': {
                                                    color: theme.palette.custom?.hoverMainMenuColor,
                                                    backgroundColor: theme.palette.custom?.hoverMainMenuBackgroundColor,
                                                },
                                            }}
                                        >
                                            <i className={child.icon}/>
                                            {child.label}
                                        </MenuItem>
                                    ))}
                                </Box>
                            </>
                        ) : (
                            <ButtonMenu
                                component={Link}
                                href={item.link || '#'}
                                sx={{
                                    fontWeight: 700,
                                    textTransform: 'none',
                                }}
                            >
                                <i className={item.icon}/>
                                {item.label}
                            </ButtonMenu>
                        )}
                    </Box>
                ))
            }
        </>
    );
};

export default DesktopMenu;
